module.exports = __webpack_public_path__ + "img/logo_advanced_accelerator_applications.71e5b0eb.png";